import { iQCRuleGroup } from "@sdk/agent-quality-control/qc-rule-groups.models";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { qcRuleGroupsDefaultQueryConfig } from "./qc-rule-groups-default-query";

export const {
  slice: QCRuleGroupsSlice,
  reducers: QCRuleGroupsSliceReducer,
  actions: {
    setEntityQueryResults: setQCRuleGroupsQueryResults,
    setEntity: setQCRuleGroup,
    setEntities: setQCRuleGroups,
    patchEntity: patchQCRuleGroup,
    addNewEntity: addNewQCRuleGroup,
    setEntityFetchingStatus: setQCRuleGroupFetchingStatus,
    setEntitiesFetchingStatus: setQCRuleGroupsFetchingStatus,
    setEntityFailedStatus: setQCRuleGroupFailedStatus,
    setEntityQueryError: setQCRuleGroupsQueryError,
    resetQuery: resetQCRuleGroupsQuery,
    setQueryList: setQCRuleGroupQueryList,
  },
} = CreateEntitySlice<iQCRuleGroup>({
  sliceName: "qcRuleGroups",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...qcRuleGroupsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
